import React, {useState, useEffect} from 'react';
import {Switch, Route, useLocation} from 'react-router-dom';

import './estilos/css/App.css';
import {AuthProvider} from './hooks/context/authContext';
import AdminDash from './pages/router/AdminDash';
import Login from './pages/Login';
import SSOLogin from './pages/SSOLogin';
import PrivateRoute from './components/PrivateRoute';

import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditarFichaDatosGlobal from './pages/gestionNuevosIngresos/ficha/EditarFichaDatosGlobal';
import PrePostNatalPublic from './pages/registroMaternidad/public/PrePostNatalPublic';
import HorarioLactanciaPublic from './pages/registroMaternidad/public/HorarioLactanciaPublic';
import EditarFichaDatosGlobalNuevosPostulantes
    from "./pages/gestionNuevosPostulantes/ficha/EditarFichaDatosGlobalNuevosPostulantes";
import EvaluacionesPostulante from './pages/evaluacionesPostulante/EvaluacionesPostulante';
toast.configure()
library.add(fas);
const App = () => {
    const location = useLocation();

    return (
        <>
            
            <AuthProvider>
                <Switch>
                    <Route component={SSOLogin} path='/sso' />
                    <Route component={() => <Login url={location?.state}/>} path='/login'/>
                    <Route component={EditarFichaDatosGlobal} path='/datosNuevoIngreso'/>
                    <Route component={EditarFichaDatosGlobalNuevosPostulantes} path='/datosNuevoPostulante'/>
                    <Route component={EvaluacionesPostulante} path='/evaluacionesPostulante' /> {/* Nueva Ruta */}
                    <Route component={PrePostNatalPublic} path='/Maternidad/GuardarPrePostNatal'/>
                    <Route component={HorarioLactanciaPublic} path='/Maternidad/GuardarHorarioLactancia'/>
                    <PrivateRoute component={AdminDash} path='/'/>
                </Switch>
            </AuthProvider>
        </>
    );
};

export default App;
